/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardListEntryScope } from './DashboardListEntryScope';
import {
    DashboardListEntryScopeFromJSON,
    DashboardListEntryScopeFromJSONTyped,
    DashboardListEntryScopeToJSON,
    DashboardListEntryScopeToJSONTyped,
} from './DashboardListEntryScope';
import type { DashboardListEntryCategory } from './DashboardListEntryCategory';
import {
    DashboardListEntryCategoryFromJSON,
    DashboardListEntryCategoryFromJSONTyped,
    DashboardListEntryCategoryToJSON,
    DashboardListEntryCategoryToJSONTyped,
} from './DashboardListEntryCategory';

/**
 * 
 * @export
 * @interface DashboardListEntry
 */
export interface DashboardListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    omni_dashboard_id?: string;
    /**
     * 
     */
    is_admin: boolean;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    description: string;
    /**
     * 
     */
    is_favorite: boolean;
    /**
     * 
     */
    scope: DashboardListEntryScope;
    /**
     * 
     */
    category: DashboardListEntryCategory;
}



/**
 * Check if a given object implements the DashboardListEntry interface.
 */
export function instanceOfDashboardListEntry(value: object): value is DashboardListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('is_admin' in value) || value['is_admin'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('is_favorite' in value) || value['is_favorite'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function DashboardListEntryFromJSON(json: any): DashboardListEntry {
    return DashboardListEntryFromJSONTyped(json, false);
}

export function DashboardListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'omni_dashboard_id': json['omni_dashboard_id'] == null ? undefined : json['omni_dashboard_id'],
        'is_admin': json['is_admin'],
        'title': json['title'],
        'description': json['description'],
        'is_favorite': json['is_favorite'],
        'scope': DashboardListEntryScopeFromJSON(json['scope']),
        'category': DashboardListEntryCategoryFromJSON(json['category']),
    };
}

export function DashboardListEntryToJSON(json: any): DashboardListEntry {
    return DashboardListEntryToJSONTyped(json, false);
}

export function DashboardListEntryToJSONTyped(value?: DashboardListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'omni_dashboard_id': value['omni_dashboard_id'],
        'is_admin': value['is_admin'],
        'title': value['title'],
        'description': value['description'],
        'is_favorite': value['is_favorite'],
        'scope': DashboardListEntryScopeToJSON(value['scope']),
        'category': DashboardListEntryCategoryToJSON(value['category']),
    };
}

